// Add these two new functions
function disableBodyScroll() {
  document.body.classList.add('no-scroll');
}

function enableBodyScroll() {
  document.body.classList.remove('no-scroll');
}

// Function to open any popup
function openPopup(popupId) {
  const popup = document.getElementById(popupId);
  const blurredBackground = document.getElementById('blurred-background-' + popupId);
  popup.style.display = 'block';
  popup.setAttribute('aria-hidden', 'false');
  blurredBackground.style.display = 'block';
  disableBodyScroll();  // Disable body scroll when popup opens
}

// Function to close any popup
function closePopup(popupId) {
  const popup = document.getElementById(popupId);
  const blurredBackground = document.getElementById('blurred-background-' + popupId);
  popup.style.display = 'none';
  popup.setAttribute('aria-hidden', 'true');
  blurredBackground.style.display = 'none';
  // Remove the 'active' class from all buttons related to this popup
  document.querySelectorAll(`[data-popup-id="${popupId}"].active`).forEach(btn => btn.classList.remove('active'));
  enableBodyScroll();  // Enable body scroll when popup closes
}

// Initialize popups
document.addEventListener('DOMContentLoaded', function () {
  // Event listeners for opening the popup
  document.querySelectorAll('[data-popup-id]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
    
      const popupId = button.getAttribute('data-popup-id');
      openPopup(popupId);
      button.classList.add('active');
    });
  });

  // Event listeners for closing the popup
  document.querySelectorAll('.japop-closePopupButton').forEach(function (closeButton) {
    closeButton.addEventListener('click', function () {
      // const popupId = closeButton.closest('[id]').id;
      const popupId = closeButton.closest('.japop-popup').id;
      closePopup(popupId);
    });
  });

  // Close the popup when clicking on the blurred background
  document.querySelectorAll('[id^=blurred-background-]').forEach(function (background) {
    background.addEventListener('click', function () {
      const popupId = background.id.replace('blurred-background-', '');
      closePopup(popupId);
    });
  });
});
